<template>
<div>
  <!-- 默认样式 -->
  <div
    class="athena-product-item"
    :class="{ 'athena-product-item--stock': !computed_price.buy_able }"
    v-if="groupProduct.style === 'default' && (groupProduct.position === 'button_above' || groupProduct.position === 'button below')"
  >
    <div class="athena-product-item-left">
      <a :href="product.path">
        <v-lazy-img  
          :src="(mix_now_image_data && mix_now_image_data.thumbnail) || defaultImage"
          :data-url="(mix_now_image_data && mix_now_image_data.url) || defaultImage"
          ></v-lazy-img>
      </a>
    </div>
    <div class="athena-product-item-right clearfix">
      <div class="apir-product-title">
        <a :href="product.path" class="text-overflow-2">
          {{ product.post_title }}
        </a>
      </div>
      <div class="apir-product-price">
        <v-simplePrice
          mode="regular_price"
          v-if="computed_price.price < computed_price.regular_price"
          :price="computed_price.regular_price"
        ></v-simplePrice>
        <v-simplePrice :price="computed_price.price"></v-simplePrice>
      </div>
      <div class="apir-product-attr">
        <!-- 有特殊属性时候布局 -->
        <div class="apir-product-attr--special" v-if="has_special_attrs">
          <div class="text-overflow-1">
            {{ $store.state.special_attr_key }}
          </div>
          <template v-for="(item, index) in product_res.variant_attrs">
            <div :key="item.name + index" v-if="item.special_native_name">
              <v-selectStyle
                @click.native="follow_main_variant_list = false"
                :variant_attrs="variant"
                :index="index"
                :key_name="uniqueKey(['athenaGroupedProduct', product_res.ID])"
                :attrs="item"
                theme="athena"
                :show_dropdown="true"
              ></v-selectStyle>
            </div>
          </template>
        </div>
        <!-- 普通属性和特殊属性分开布局,经过特殊处理的属性都会有special_native_name字段，根据special_native_name字段判断当前属性是否特殊属性 -->
        <div class="apir-product-attr--normal">
          <template v-for="(item, index) in product_res.variant_attrs">
            <div :key="item.name + index" v-if="!item.special_native_name">
              <div class="text-overflow-1">
                {{ item.name }}
              </div>
              <v-selectStyle
                :variant_attrs="variant"
                :index="index"
                :attrs="item"
                :key_name="uniqueKey(['athenaGroupedProduct', product_res.ID])"
                theme="athena"
                :show_dropdown="true"
              ></v-selectStyle>
            </div>
          </template>
          <div v-if="groupProduct.position === 'button_above'">
            <label for="count" class="label" style="margin: 0"> Qty </label>
            <v-inputnum
              mode="notBoder"
              v-model="add_cart_data.quantity"
              :min="1"
              :step="1"
            ></v-inputnum>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- 卡片样式 -->
  <div
    class="athena-product-item-card"
    :class="{ 'athena-product-item-card--stock': !computed_price.buy_able }"
    v-else
  >
    <div class="athena-product-item-card__header">
      <a :href="product.path">
        <v-lazy-img  
          :src="(mix_now_image_data && mix_now_image_data.thumbnail) || defaultImage"
          :data-url="(mix_now_image_data && mix_now_image_data.url) || defaultImage"
          ></v-lazy-img>
      </a>
    </div>
    <div class="athena-product-item-card__footer">
      <!-- 标题 -->
      <div class="athena-product-item-card__title title_font">
        <a :href="product.path" class="text-overflow-2">
          {{ product.post_title }}
        </a>
      </div>
      <!-- 数量 -->
      <div class="athena-product-item-card__qtm">
        <v-inputnum
          mode="notBoder"
          v-model="add_cart_data.quantity"
          :min="1"
          :step="1"
        ></v-inputnum>
      </div>
      <!-- 选择变种 -->
      <div class="athena-product-item-card__var" :class="{varHeight:!(product_res && product_res.variant_attrs && product_res.variant_attrs.length)}">
        <v-athena-product-item-btn
          :theme="theme"
          :product_res="product_res"
          :variant_attrs="variant"
          :computed_price="computed_price"
        ></v-athena-product-item-btn>
      </div>
      <!-- 价格 -->
      <div class="athena-product-item-card__price page_text_font">
        <v-simplePrice
          mode="regular_price"
          v-if="computed_price.price < computed_price.regular_price"
          :price="computed_price.regular_price"
        ></v-simplePrice>
        <v-simplePrice :price="computed_price.price"></v-simplePrice>
      </div>
    </div>

  </div>
</div>

</template>
<script>
import { mapState } from 'vuex';
import mixProduct from "@/js/mixins/mixProduct";
import vSelectStyle from "@/views/venue/js/view/product/selectStyle.vue";
import vAthenaProductItemBtn from "./athenaProductItemBtn.vue";
import vInputnum from "@/views/venue/js/common/inputnum.vue";
export default {
  props: ["product"],
  data() {
    return {
      theme: "athena",
      follow_main_variant_list: true, //变种属性是否跟随主商品 仅power生效,用户选择一次变种后失效
    };
  },
  mixins: [mixProduct],
  components: { vSelectStyle, vAthenaProductItemBtn , vInputnum},
  methods: {
    add_cart_payload() {
      let payload = {
        id: this.product.ID,
        add_card_payload: this.add_cart_list?.length
          ? this.add_cart_list
          : [this.add_cart_data],
        computed_price: this.computed_price,
      };
      this.$emit("add_cart_payload", payload);
    },
  },
  watch: {
    "$store.state.variant_list": {
      handler(newV) {
        if (
          !this.has_special_attrs ||
          !newV.length ||
          !this.variant.length ||
          !this.follow_main_variant_list
        )
          return;
        this.variant = this.variant.map((item) => {
          newV.some((subItem) => {
            if (
              item.name == subItem.name &&
              this.special_attrs_value.includes(subItem.value)
            ) {
              item.value = subItem.value;
              return true;
            }
          });
          return item;
        });
      },
      deep: true,
    },
  },
  beforeMount(){
    console.log(this.product,'productproduct');
  },
  mounted() {
    this.add_cart_payload();
  },
  computed: {
    ...mapState({
      // 组合商品配置
      groupProduct: ({ plugConfig }) => plugConfig.groupProduct || {}
    }),
  },
};
</script>
<style scoped lang='scss'>
.athena-product-item {
  display: flex;
  &-left {
    width: 68px;
    height: 68px;
    a {
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #efefef;
      width: 100%;
      height: 100%;
      img {
        max-width: 100%;
        max-height: 100%;
      }
    }
  }
  &-right {
    flex: 1;
    padding-left: 14px;
    color: #222222;
    .apir-product-title {
      width: 60%;
      float: left;
      white-space: normal;
      line-height: 24px;
      font-size: 14px;
      font-family: Roboto;
      font-weight: 500;
      color: #262626;
    }
    .apir-product-price {
      width: 40%;
      float: right;
      text-align: right;
      & > span {
        display: block;
        font-size: 14px;
        font-family: Roboto;
        font-weight: 400;
        line-height: 20px;
      }
    }
    .apir-product-attr {
      float: left;
      width: 100%;
      max-width: 262px;
      ::v-deep.select-style-box {
        .default-select {
          &::after {
            content: "\e607";
            color: #2f2f30;
            font-weight: 600;
            font-size: 12px;
            right: 5px;
          }
          select {
            margin: 0;
            padding: 0 10px !important;
            height: 30px;
            font-size: 14px;
            font-family: Roboto;
            font-weight: 400;
            line-height: 30px;
            color: #3a3a3a;
          }
        }
      }
      &--special {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        margin-top: 14px;
        line-height: 14px;
        .text-overflow-1 {
          max-width: 60px;
        }
        & > div:not(.text-overflow-1) {
          flex: 1;
          padding: 0 10px;
          &:first-child {
            padding-left: 9px;
          }
          &:last-child {
            padding-right: 0;
          }
        }
      }
      &--normal {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: space-between;
        & > div {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-top: 14px;
          width: 50%;
          .text-overflow-1 {
            max-width: 60px;
          }
          &:nth-child(even) {
            justify-content: flex-end;
            & > div {
              margin-left: 10px;
            }
          }
          .select-style-box {
            flex: 1;
            max-width: 80px;
          }
        }
      }
    }
  }
}
.athena-product-item--stock {
  .athena-product-item-left {
    position: relative;
    &::after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba($color: #000000, $alpha: 0.3);
      color: white;
      text-align: center;
      line-height: 68px;
      font-size: 12px;
    }
  }
}

.athena-product-item-card {
  box-shadow: 0px 2px 16px rgba(0, 0, 0, 0.1);
  &__header {
    width: 100%;
    box-sizing: inherit;
    position: relative;
    min-height: 100px;
    a {
      display: block;
      width: 100%;
      padding-top: 100%;
      position: relative;
      img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        -o-object-fit: contain !important;
        object-fit: contain !important;
        -webkit-backface-visibility: hidden;
        backface-visibility: hidden;
        transition: all 0.3s ease-in-out;
      }
    }
  }
  &__footer {
    padding: 14px 10px 20px;
  }
  &__title {
    font-weight: bold;
    margin-bottom: 10px;
    height: 40px;
  }
  &__var {
    &.varHeight {
      height: 57px;
    }
  }
  &__qtm {
    text-align: center;
    ::v-deep {
      .product_qty {
        display: block;
        width: 100%;
        height: 40px;
        margin-bottom: 10px;
      }
    }
  }
  &__price {
    text-align: right;
    padding-left: 20px;
    & > span {
      white-space: nowrap;
    }
  } 
}
.athena-product-item-card--stock {
  .athena-product-item-card__header {
    position: relative;
    &::after {
      content: "SOLD OUT";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba($color: #000000, $alpha: 0.3);
      color: white;
      font-size: 16px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}
@media screen and(max-width: 768px) {
  .athena-product-item {
    &-left {
      width: 60px;
      height: 60px;
    }
    &-right {
      padding-left: 9.5px;
      .apir-product-title {
        font-size: 13px;
      }
      .apir-product-price {
        & > span {
          display: block;
          font-size: 13px;
          font-family: Roboto;
          font-weight: 400;
          line-height: 15px;
        }
      }
      .apir-product-attr {
        ::v-deep.select-style-box {
          .default-select {
            select {
              height: 21px;
              line-height: 21px;
              font-size: 12px;
            }
          }
        }
        &--special {
          margin-top: 10px;
          & > div {
            padding: 0 5px;
            &:first-child {
              padding: 0;
            }
          }
        }
        &--normal {
          font-size: 12px;
          & > div {
            margin-top: 10px;
            &:nth-child(even) {
              justify-content: flex-end;
              & > div {
                margin-left: 10px;
              }
            }
          }
        }
      }
    }
  }
  .athena-product-item-card {
    &__qtm {
      ::v-deep {
        .product_qty {
          height: 34px;
        }
      }
    }
    &__title {
      margin-bottom: 4px;
    }
    &__var {
      &.varHeight {
        height: 50px;
      }
    }
    &__price {
      font-size: 13px;
    }
  }
}
</style>